import React from "react";
import DatePicker from "react-datepicker";
import SbuxRadioGroup from "../../../../../../components/SbuxRadioGroup";
import { Box, FormControlLabel, Radio } from "@mui/material";
import dayjs from "../../../../../../utils/dayjs";
import styles from "../../../styles";
import { DAYS_TO_ADD } from "../../../../../../constants";
import useCss from "../../../../../../hooks/useCss";
import type { Dayjs } from "dayjs";

interface Props {
  endByOption: string;
  endByEndDate: Date | Dayjs | null;
  handleEndByEndDateChange: (date: Date | null) => void;
  handleEndByOptionsValueChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  isAdd?: boolean;
}

const ClosureMsgRangeRecurrence = ({
  endByOption,
  endByEndDate,
  handleEndByEndDateChange,
  handleEndByOptionsValueChange,
  isAdd = false,
}: Props) => {
  const classes = useCss(styles);

  return (
    <SbuxRadioGroup
      value={endByOption}
      handleRadioButtonChange={handleEndByOptionsValueChange}
    >
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flex: 2 }}>
          <FormControlLabel
            value={"endByEndDate"}
            control={<Radio size="small" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  pointerEvents:
                    endByOption !== "endByEndDate" ? "none" : undefined,
                  opacity: endByOption !== "endByEndDate" ? 0.6 : undefined,
                }}
              >
                <Box
                  sx={{
                    marginRight: 1,
                    fontSize: 13,
                    marginTop: 0.5,
                  }}
                >
                  {"Date"}
                </Box>
                <Box
                  sx={{
                    marginRight: 1,
                    fontSize: 13,
                    flex: 1,
                  }}
                >
                  <DatePicker
                    className={classes.datePicker}
                    wrapperClassName={classes.recDatePickerWrapper}
                    selected={
                      endByEndDate
                        ? endByEndDate instanceof Date
                          ? endByEndDate
                          : (endByEndDate as { toDate: () => Date }).toDate()
                        : null
                    }
                    minDate={dayjs().add(DAYS_TO_ADD, "days").toDate()}
                    onChange={(date) => handleEndByEndDateChange(date)}
                  />
                </Box>
              </Box>
            }
          />
        </Box>
        <Box sx={{ flex: 3 }}>
          <FormControlLabel
            value={"endByNoDate"}
            control={<Radio size="small" />}
            label={
              <Box
                sx={{
                  display: "flex",
                  fontSize: 13,
                  flex: 1,
                  pointerEvents:
                    endByOption !== "endByNoDate" ? "none" : undefined,
                  opacity: endByOption !== "endByNoDate" ? 0.6 : undefined,
                }}
              >
                <Box
                  sx={{
                    fontSize: 13,
                    marginTop: 0.5,
                    flex: 1,
                  }}
                >
                  {"No end date"}
                </Box>
              </Box>
            }
          />
        </Box>
        {isAdd === true && (
          <Box
            sx={{
              color: "#006241",
              fontSize: 12,
              fontWeight: 600,
              marginLeft: -1,
              marginTop: 1.3,
            }}
          >
            {"Date should be in the future"}
          </Box>
        )}
      </Box>
    </SbuxRadioGroup>
  );
};

export default ClosureMsgRangeRecurrence;
